import Modal from 'components/_parts/atoms/modal';
import { useOuterClick } from 'providers/OutsideClick';
import { useState } from 'react';
import styled from 'styled-components';
import 'components/_parts/molecules/Prompt/OrgChart/index.scss';
import Button from 'components/_parts/atoms/button';
import { useDispatch } from 'react-redux';
import {
  HIT_EMPLOYEE_CHART, HIT_LIST_EMPLOYEE, HIT_STRUCTURE, HIT_UPDATE_STRUCTURE,
} from 'redux/actions/organization';
import { useTranslation } from 'react-i18next';
import { useUpdateEmployee } from 'components/organizations/employees/api/useEmployee';

const ContainerPrompt = styled.div`
    max-width: 450px;
    height: 150px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    row-gap: 20px;
`;

const WrapperBtn = styled.div`
    display:flex;
    flex-direction: row;
    column-gap: 20px;
`;

function useOrgChart(type, isFocusPosition, idFocus) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isShow, setIsShow] = useState(false);
  const [dataOrg, setDataOrg] = useState({
    structure: {},
    employee: {},
  });

  const { mutate: deleteEmployee } = useUpdateEmployee();

  const myRef = useOuterClick((e) => {
    if (e.target.className.includes('prompt-delete')) {
      setIsShow(false);
    }
  });

  const fetchChart = {
    structure: () => setTimeout(() => {
      dispatch({
        type: HIT_STRUCTURE,
        payload: {
          board_id: localStorage.getItem('board_id'),
        },
      });
    }, 300),
    employee: () => setTimeout(() => {
      dispatch({
        type: HIT_EMPLOYEE_CHART,
        payload: {
          board_id: localStorage.getItem('board_id'),
          organization_id: '008689ae-a3ad-11e9-8f66-b42e992b9a51',
        },
      });
      dispatch({
        type: HIT_LIST_EMPLOYEE,
        payload: {
          board_id: localStorage.getItem('board_id'),
        },
      });
    }, 500),
  };

  const deleteDataOrg = () => {
    const typeOfOrg = {
      structure: () => {
        dispatch({
          type: HIT_UPDATE_STRUCTURE,
          payload: {
            data: {
              organization_id: dataOrg.structure['Organization ID'],
              job_grade: dataOrg.structure['Job Grade'],
              job_level: dataOrg.structure['Job Level*'],
              report_to_id: dataOrg.structure['Report to'],
              purpose: dataOrg.structure.Purpose,
              name: dataOrg.structure.Nama,
              tag: dataOrg.structure.Tag,
              status: '0',
              board_id: localStorage.getItem('board_id'),
            },
            board_id: localStorage.getItem('board_id'),
            isFocusPosition,
            idFocus,
          },
        });
      },
      employee: async () => {
        if (dataOrg.employee.employee_profile === null) {
          dataOrg.employee.employee_profile = '';
        }
        const employeeId = dataOrg.employee.employee_id;
        const payloadEmployee = {
          employee_id: employeeId,
          status: 0,
        };

        deleteEmployee(payloadEmployee);
      },

    };
    return typeOfOrg[type]();
  };

  const promptDelete = () => (
    <Modal modal={isShow} classIdentifier="prompt-delete" type="orgChart">
      <ContainerPrompt ref={myRef}>
        <div>
          <h4 className="ch-prompt-delete-text-question">
            {t('general.message.del_org')}
          </h4>
        </div>
        <WrapperBtn>
          <Button
            func={() => {
              setIsShow(false);
              deleteDataOrg();
            }}
            className="ch-prompt-delete-btn-accept"
          >
            {t('org.job_lvl.form.yes')}
          </Button>
          <Button func={() => { setIsShow(false); }} className="ch-prompt-delete-btn-decline">{t('org.job_lvl.form.no')}</Button>
        </WrapperBtn>
      </ContainerPrompt>
    </Modal>
  );

  return {
    dataOrg, fetchChart, promptDelete, setIsShow, setDataOrg,
  };
}

export default useOrgChart;
